<template>
  <el-dialog
    title="支付确认"
    :visible.sync="visible"
    width="600px"
    @close="$emit('update:show', false)"
  >
    <el-form
      size="small"
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100"
    >
      <el-form-item label="支付凭证" prop="payed_proof">
        <el-upload
          :action="uploadUrl"
          accept="image/*"
          :headers="uploadHeader"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeAvatarUpload"
          style="display: inline-block; width: 100%"
        >
          <auth-img
            tag="el-image"
            style="width: 100px; height: 100px"
            :src="model.payed_proof"
            fit="cover"
            v-if="model.payed_proof"
          ></auth-img>
          <span v-else class="font-12">点击上传{{ model.payed_proof }}</span>
        </el-upload>
      </el-form-item>
      <el-form-item label="支付日期" prop="payed_at">
        <div style="width: 100%; display: flex">
          <el-date-picker
            v-model="model.payed_at"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="备注" prop="payed_remark">
        <el-input type="textarea" v-model="model.payed_remark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="submitForm"
        :loading="submiting"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import store from '@/store/store'
import { urlPerfix } from '@/config/env'
import { commodityOrderPay } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      submiting: false,
      uploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      rules: {
        payed_proof: [{ required: true, message: '请上传支付凭证' }],
        payed_at: [{ required: true, message: '请选择支付时间' }],
      },
    }
  },
  methods: {
    submitForm() {
      if (this.submiting) return
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res = await commodityOrderPay(this.model)
          if (res.code == 0) {
            this.$emit('updated', res.data)
          }
          this.visible = false
        } else {
          this.submiting = false
          console.log('error submit!!')
          return false
        }
      })
    },

    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.model.payed_proof = res.data
        this.$refs.form.validateField('payed_proof')
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeAvatarUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 < this.uploadLimitSize.file
      if (!isLimitSize) {
        this.$message.error(`文件大小不能超过 ${this.uploadLimitSize.file}MB!`)
      }
      return isLimitSize
    },
  },
}
</script>